import { observer } from 'mobx-react-lite'
import { SectionHeader } from '../../components/SectionHeader/SectionHeader'
import { FavoritesTree } from './FavoritesTree/FavoritesTree'
import { reverse } from 'lodash'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import { useFavorites } from 'hooks/queries/favorites/useFavorites'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useLeftSidebarChannel } from 'hooks/useLeftSidebarChannel'
import { FAVORITES_PATH } from 'paths'
import { generatePath, Link } from 'react-router-dom'
import { useFavoritesChannel } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useFavoritesChannel'
import { ExpandableTree, useExpandable } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useExpandable'
import Styles from '../../WorkspaceDashboardSidebarContent.module.scss'
import SectionHeaderStyles from '../SectionHeader/SectionHeader.module.scss'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'

const Favorites = observer(() => {
  const { toggle, expanded } = useExpandable(ExpandableTree.Favorites)
  const currentWorkspaceId = useCurrentWorkspaceId()
  const isVirtualMarketer = useIsVirtualMarketer()
  const { data, isFetched } = useFavorites()
  const favorites = data
    ? reverse(data.filter(({ favoritable_workspace_id }) => favoritable_workspace_id === currentWorkspaceId))
    : []

  const websocketConnection = useWebsocketConnection()
  useFavoritesChannel({ websocketConnection, favorites })
  useLeftSidebarChannel('favorites')

  if (isFetched && favorites?.length === 0) return null

  return (
    <div className={Styles.section}>
      <SectionHeader
        label="Favorites"
        data-test-id="favorites-button"
        isExpanded={expanded}
        onPress={toggle}
        action={
          isVirtualMarketer ? undefined : (
            <div className={SectionHeaderStyles.seeAllButton}>
              <ButtonLink
                variant="tertiary"
                size="xs"
                to={generatePath(FAVORITES_PATH, { workspaceId: currentWorkspaceId })}
                elementType={Link}
              >
                See all
              </ButtonLink>
            </div>
          )
        }
      />
      {expanded && <>{<FavoritesTree favorites={favorites} />}</>}
    </div>
  )
})

export { Favorites }
